import { Label } from "@/components/atoms/texts/label";
import PrintErrorMessage from "@/components/organisms/feedback/PrintErrorMessage";
import DragAndDropZone from "@/components/organisms/forms/DragAndDropZone";
import { Input } from "@/components/ui/input";
import { useEffect, useRef, useState } from "react";

export default function FormPayslipBook({ global = true, refetchFromScratch, submitRef,setDisableAnalayse, onSubmit, submissionError }) {
    const [file, setFile] = useState(null);
    const [paymentDate, setPaymentDate] = useState('');
    const [fileError, setFileError] = useState(null);
    const [paymentDateError, setPaymentDateError] = useState(null);
    // const [submissionError, setSubmissionError] = useState(false);
    const [submissionSuccess, setSubmissionSuccess] = useState(false);
    const [submissionLoading, setSubmissionLoading] = useState(false);
    const scrollContainerRef = useRef(null);

    const scrollToTop = () => {
        // importer le hook useRef : import {useRef} from "react";
        // Déclarer la ref :     const scrollContainerRef = useRef(null);
        // ajouter au contenant : className="h-full overflow-auto" ref={scrollContainerRef} 
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop = 0; // Définit la position de défilement à 0 pour remonter en haut
        }
    };

    const handleSubmitForm = (e) => {
        e?.preventDefault(); // Empêche le rechargement de la page
        const valid = file !== null && !!paymentDate; // Validation simple pour vérifier les champs requis

        if (!paymentDate) {
            setPaymentDateError(true);
        } else {
            setPaymentDateError(false);
        }

        if (!file) {
            setFileError("Please select a file.");
        } else {
            setFileError(null);
        }

        if (valid) {
            const formData = {
                payslipFile: file, // Structuration correcte de formData
                paymentDate,
            };
            onSubmit(formData); // Appelle la fonction de soumission passée en props
            scrollToTop();
            
        } else {
            console.error("Form error detected: Missing file or payment date");
            scrollToTop();
        }
    };

    useEffect(() => {
        // if (file && paymentDate) {
        //     handleSubmitForm();
        // }
        setDisableAnalayse(!(file && paymentDate));
    }, [file, paymentDate]);

    useEffect(() => {
        if (submissionError) {
            setFile(null); // Réinitialise le fichier sélectionné
            setPaymentDate('');
            setFileError(null); // Réinitialise les erreurs de fichier
            setPaymentDateError(null);
        }
    }, [submissionError]);

    return (
        <div className="h-full overflow-auto " ref={scrollContainerRef} >

            {submissionError && <PrintErrorMessage error={submissionError} />}

            <form onSubmit={handleSubmitForm} className="flex flex-col gap-thirdDegree  p-4" >
                {/* <Label></Label> */}
                <Label fontWeight="bold" className="col-span-1" message="global.actions.chooseFile" />
                <DragAndDropZone
                    file={file}
                    setFile={setFile}
                    fileError={fileError}
                    accept="application/pdf, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    // onChange={()=> {console.log("file loaded", file); file && submitRef.click()}}
                />

                <div className='grid grid-cols-4 items-center gap-secondDegree w-full'>
                    <Label fontWeight="bold" className="col-span-1" message="consultants.payslip.paymentDate" />
                    <Input
                        value={paymentDate}
                        type="date"
                        onChange={(e) => setPaymentDate(e.target.value)}
                        className={`col-span-3 p-2 border rounded-md text-body ${paymentDateError === true && `border-error`} ${paymentDateError === false && `border-success`} ${paymentDateError == null && `border-greyStrong`} `}
                    />
                </div>

                <Input type='submit' id="submitFormNewPayslip" className='hidden' ref={submitRef} />
            </form>

        </div>


    )
}